module.exports = __webpack_public_path__ + "odinstatic/v5.0.2/media/manual-placement.9726886b.svg";